import { useState, useEffect } from "react";

const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [isIOSDevice, setIsIOSDevice] = useState(false);

  useEffect(() => {
    // 1. Uygulamanın zaten PWA olarak (ana ekrandan) açılıp açılmadığını kontrol et
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone;
    if (isStandalone) return; // Zaten yüklüyse popup gösterme

    // 2. iOS (iPhone/iPad) kontrolü
    const iosCheck =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    setIsIOSDevice(iosCheck);

    // Eğer cihaz iOS ise, beforeinstallprompt tetiklenmeyeceği için popup'ı direkt süreye bağlı gösterelim
    if (iosCheck) {
      const timer = setTimeout(() => setShowPopup(true), 4000); // 4 saniye sonra göster
      return () => clearTimeout(timer);
    }

    // 3. Android ve Web için Standart PWA Prompt Yakalama
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setTimeout(() => setShowPopup(true), 3000);
    };

    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") {
      console.log("ClassRoom yüklendi!");
    }

    setDeferredPrompt(null);
    setShowPopup(false);
  };

  if (!showPopup) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[100] w-[90%] max-w-md animate-bounce-in">
      <div className="bg-white/95 backdrop-blur-sm border border-blue-100 shadow-2xl rounded-2xl p-5 flex flex-col gap-3">
        {/* Üst Kısım: Logo ve Başlık */}
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg shadow-blue-200">
              <span className="text-white font-bold text-xl">C</span>
            </div>
            <div>
              <h4 className="font-bold text-gray-800 text-sm">
                ClassRoom'u Yükle
              </h4>
              <p className="text-xs text-gray-500 italic">
                Eğitime hızlıca devam et!
              </p>
            </div>
          </div>

          {/* Android/Web için Butonlar (iOS değilse burası görünür) */}
          {!isIOSDevice && (
            <div className="flex gap-2">
              <button
                onClick={() => setShowPopup(false)}
                className="text-gray-400 hover:text-gray-600 text-xs font-medium px-2 py-1"
              >
                Kapat
              </button>
              <button
                onClick={handleInstall}
                className="bg-blue-600 hover:bg-blue-700 text-white text-xs font-bold px-4 py-2 rounded-lg transition-all active:scale-95 shadow-md shadow-blue-200"
              >
                Yükle
              </button>
            </div>
          )}
        </div>

        {/* 4. iOS (iPhone) Kullanıcıları İçin Özel Bilgilendirme Alanı */}
        {isIOSDevice && (
          <div className="border-t border-gray-100 pt-3 mt-1 text-center md:text-left">
            <p className="text-xs text-gray-700 leading-relaxed">
              iPhone cihazınıza yüklemek için aşağıdaki tarayıcı menüsünden
              <span className="font-bold text-blue-600"> "Paylaş" </span>
              butonuna basın, ardından listeyi kaydırarak
              <span className="font-bold text-blue-600">
                {" "}
                "Ana Ekrana Ekle"
              </span>{" "}
              seçeneğini seçin.
            </p>
            <div className="flex justify-end mt-2">
              <button
                onClick={() => setShowPopup(false)}
                className="text-gray-400 hover:text-gray-600 text-xs font-semibold px-3 py-1 bg-gray-50 rounded-md"
              >
                Anladım, Kapat
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PWAInstallPrompt;
